const ELLIPSIS = '…'
const TRAILING_JOINERS = /[\s,;:|/&+·•\-–—(]+$/u

/**
 * Shortens text to at most `max` characters at a word boundary, ending in an ellipsis. Text that already
 * fits is returned as is (whitespace collapsed). Mirrors s3
 * `AdvisorApplicationExtractService/normalize.js` `clipAtWord`, so a headline is never cut mid-word
 * ("…I make early tea") by either side (walk #4).
 */
export const clipAtWord = (value: string | null | undefined, max: number): string => {
  const text = String(value || '')
    .replace(/\s+/g, ' ')
    .trim()
  if (text.length <= max) {
    return text
  }
  const budget = Math.max(max - 1, 0)
  let cut = text.slice(0, budget)
  // Only back up to the last space when the next character doesn't already start a new word.
  if (text[budget] !== ' ') {
    const lastSpace = cut.lastIndexOf(' ')
    if (lastSpace > 0) {
      cut = cut.slice(0, lastSpace)
    }
  }
  cut = cut.replace(TRAILING_JOINERS, '')
  return cut ? `${cut}${ELLIPSIS}` : `${text.slice(0, budget)}${ELLIPSIS}`
}
